import React, { useEffect, useRef, useState } from "react";
import classnames from "classnames";
import { FormattedMessage, useIntl } from "react-intl";
import { UsersTab } from "./tabs/UsersTab";
import { history, store } from "../../../../store/store";
import { GroupsTab } from "./tabs/GroupsTab";
import { ACL } from '../../../../config/constants';
import { hideNotification } from '../../../../store/actions/notification';
import { EntityTabLayout } from '../../../layout/Workspace';

function AdminManage(props) {
  const hasUsersListAccess = ACL.ADMIN.USERS.LIST.hasAccess();
  const hasGroupsListAccess = ACL.ADMIN.GROUPS.LIST.hasAccess();
  const [ activeTab, setActiveTab ] = useState( hasUsersListAccess ? 'users' : 'groups' );
  const layoutRef = useRef(null);
  const intl = useIntl();
  const {
    users, metaUsers, getUsers, rowsPerPageUsers, setRowsPerPageUsers,
    groups, metaGroups, getGroups, rowsPerPageGroups, setRowsPerPageGroups
  } = props;
  useEffect( () => {
    const tab = new URLSearchParams( props.location.search ).get( "tab" );

    if (tab) {
      if (activeTab !== tab) {
        setActiveTab( tab );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [] );

  const toggle = (tab) => {
    if (activeTab !== tab) {
      history.push( {
        search: "?" + new URLSearchParams( { tab: tab } ).toString(),
      } );

      store.dispatch(hideNotification());
      setActiveTab( tab );
    }
  };

  const tabPanels = (
    <div className="admin-management-tabs__content">
      {hasUsersListAccess && <div
        aria-hidden={activeTab !== "users"}
        className={classnames(
          'admin-management-tabs__panel admin-management-tabs__panel--users',
          { active: activeTab === 'users' }
        )}
        hidden={activeTab !== "users"}
        id="admin-management-panel-users"
      >
        <UsersTab
          users={users}
          metaUsers={metaUsers}
          getUsers={getUsers}
          rowsPerPageUsers={rowsPerPageUsers}
          setRowsPerPageUsers={setRowsPerPageUsers}
        />
      </div>}
      {hasGroupsListAccess && <div
        aria-hidden={activeTab !== "groups"}
        className={classnames(
          'admin-management-tabs__panel admin-management-tabs__panel--groups',
          { active: activeTab === 'groups' }
        )}
        hidden={activeTab !== "groups"}
        id="admin-management-panel-groups"
      >
        <GroupsTab
          groups={groups}
          metaGroups={metaGroups}
          getGroups={getGroups}
          rowsPerPageGroups={rowsPerPageGroups}
          setRowsPerPageGroups={setRowsPerPageGroups}/>
      </div>}
    </div>
  );
  const tabs = [];

  if (hasUsersListAccess) {
    tabs.push({
      id: 'users',
      label: <FormattedMessage id="pages.admins.title"/>,
      content: tabPanels
    });
  }

  if (hasGroupsListAccess) {
    tabs.push({
      id: 'groups',
      label: <FormattedMessage id="components.pages.admin.manage.groups.title"/>,
      content: tabPanels
    });
  }

  useEffect(() => {
    const hasActiveTab = (
      (activeTab === 'users' && hasUsersListAccess) ||
      (activeTab === 'groups' && hasGroupsListAccess)
    );

    if (!hasActiveTab) {
      const firstTab = layoutRef.current?.querySelector('[role="tab"]');

      if (firstTab) {
        firstTab.tabIndex = 0;
      }
    }
  }, [activeTab, hasGroupsListAccess, hasUsersListAccess]);

  return (
    <div className="admin-management-layout-root" ref={layoutRef}>
      <EntityTabLayout
        activeTab={activeTab}
        ariaLabel={intl.formatMessage({ id: 'pages.admins.manage.title' })}
        className="admin-management-layout admin-management-tabs"
        header={props.header}
        onTabChange={toggle}
        tabs={tabs}
      />
    </div>
  );
}

export { AdminManage };
